<ion-item [detail]="false">
  <ion-chip class="thumb-chip" slot="start">
    <ion-icon *ngIf="boulderListEntry.rating>0" class="good-boulder" name="thumbs-up"></ion-icon>
    <ion-icon *ngIf="boulderListEntry.rating<0" class="bad-boulder" name="thumbs-down"></ion-icon>
    <ion-icon *ngIf="boulderListEntry.rating==0" color="yellow" name="chevron-forward-outline"></ion-icon>
    <ion-label *ngIf="boulderListEntry.rating!=0"
               [ngClass]="boulderListEntry.rating > 0 ? 'good-boulder' : (boulderListEntry.rating<0?'bad-boulder':'')">{{boulderListEntry.rating}}</ion-label>
  </ion-chip>
  <ion-label class="boulder-label">
    <ion-text color="primary">
      <h2>
        {{boulderListEntry.boulderName | truncate : 30 }}
      </h2>
    </ion-text>
    <p>
      <ion-chip class="grade-chip">
        <ion-label>{{boulderListEntry.grade|boulderGrade}}</ion-label>
      </ion-chip>
      <ion-chip class="mini-chip ticked-chip" *ngIf="boulderListEntry.ticked">
        <ion-icon name="checkmark-circle-outline"></ion-icon>
        <ion-label>{{"boulder-list-entry-component.ticked" | translate}}</ion-label>
      </ion-chip>
      <ion-chip *ngIf="boulderListEntry.isCampus" class="mini-chip campus-chip">
        <ion-label>{{"foothold-details-component.campus" | translate}}</ion-label>
      </ion-chip>
      <ion-chip *ngIf="boulderListEntry.isPrivate" class="mini-chip draft-chip">
        <ion-label>{{"boulder-list-entry-component.draft" | translate}}</ion-label>
      </ion-chip>
      <ion-chip class="mini-chip project-chip" *ngIf="boulderListEntry.numAscents === 0">
        <ion-icon name="construct-outline"></ion-icon>
        <ion-label>{{"boulder-list-entry-component.project" | translate}}</ion-label>
      </ion-chip>
      <ion-chip class="mini-chip project-chip" *ngIf="boulderListEntry.isProject && !boulderListEntry.ticked">
        <ion-icon name="construct-outline"></ion-icon>
        <ion-label>{{"boulder-details-page.your-project" | translate}}</ion-label>
      </ion-chip>
      <i>{{"boulder-list-entry-component.by" | translate}} <username [hideSupporterIcon]="true" [username]="boulderListEntry.author"></username>
        - {{boulderListEntry.creationDate|dateFormat}}
        <span
          *ngIf="boulderListEntry.numAscents>0"> - {{boulderListEntry.numAscents}} {{(boulderListEntry.numAscents > 1 ? "boulder-list-entry-component.ascents" : "boulder-list-entry-component.ascent") | translate}}</span>
        - {{boulderListEntry.wallName}}</i></p>
  </ion-label>
</ion-item>
